import React, { useMemo } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from '../../../../../_metronic/_partials/controls';
import { injectIntl } from 'react-intl';
import ProductsFilter from './products-filter/ProductsFilter';
import ProductsTable from './products-table/ProductsTable';
import { useProductsUIContext } from './ProductsUIContext';

const ProductsCard = (props) => {
  const { intl } = props;
  const title = intl.formatMessage({ id: 'PRODUCT.TITLE.LIST' });
  const productsUIContext = useProductsUIContext();
  const productsUIProps = useMemo(() => {
    return {
      queryParams: productsUIContext.queryParams,
      setQueryParams: productsUIContext.setQueryParams,
      openViewProductDialog: productsUIContext.openViewProductDialog,
      openCreateProductDialog: productsUIContext.openCreateProductDialog,
      openDeleteProductsDialog: productsUIContext.openDeleteProductsDialog,
    };
  }, [productsUIContext]);

  return (
    <Card>
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type='button'
            className='btn btn-primary'
            onClick={productsUIProps.openCreateProductDialog}
          >
            Бүтээгдэхүүн бүртгэх
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <ProductsFilter props />
        <ProductsTable props />
      </CardBody>
    </Card>
  );
};

export default injectIntl(ProductsCard);
